import React from 'react'
import Page from '../page'
import {
  makeStyles,
  Backdrop,
  Typography,
  CircularProgress,
  Grid
} from '@material-ui/core'
import { AMNButton } from '@amn/shared'
import Components from '../../components/components'

const useStyles = makeStyles((theme) => ({
  loadingIndicator: {
    textAlign: 'center',
    margin: '100px 0px 0px 0px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFF'
  },
  tryAgainButton: {
    backgroundColor: '#FFF'
  }
}))

const ProReference = (props) => {
  const classes = useStyles()
  const {
    references,
    isEvaluator,
    errorLoadingContent,
    dataLoaded,
    loadContentAgain
  } = props

  const isEvaluationAlreadySubmitted = () => {
    try {
      if (!references || references.length === 0)
        return false
      return (isEvaluator && (references[0].ageCompetencies?.length ?? 0) > 0 && (references[0].evaluations?.length ?? 0) > 0)
    }
    catch (error) {
      console.log('Error', error)
      return false
    }
  }

  const LoadingBackdrop = () => {
    return (
      <Backdrop className={classes.backdrop} open>
        <CircularProgress className={classes.backdrop} />
      </Backdrop>
    )
  }

  const AlreadySubmittedBackdrop = () => {
    return (
      <Backdrop className={classes.backdrop} open>
        <Typography className={classes.backdrop} variant='h5'>
          This evaluation has already been submitted
        </Typography>
      </Backdrop>
    )
  }

  const ErrorLoadingContentBackdrop = () => {
    return (
      <Backdrop className={classes.backdrop} open>
        <Grid
          container
          spacing={3}
          direction='column'
          alignItems='center'
          justify='center'
        >
          <Grid item xs={12}>
            <Typography className={classes.backdrop} variant='h5'>
              There was an error loading the content.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <AMNButton onClick={loadContentAgain} className={classes.tryAgainButton} text='Try Again' />
          </Grid>
        </Grid>
      </Backdrop>
    )
  }

  return (
    <Page isEvaluator={props.isEvaluator}>
      {
        errorLoadingContent
          ? <ErrorLoadingContentBackdrop />
          : !dataLoaded
            ? <LoadingBackdrop />
            : isEvaluationAlreadySubmitted()
              ? <AlreadySubmittedBackdrop />
              : <Components {...props} />
      }
    </Page>
  )
}

export default ProReference
